
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.586 14.938c3.976 0 7.258-3.29 7.258-7.266 0-3.969-3.29-7.258-7.258-7.258C3.609.414.32 3.704.32 7.672c0 3.976 3.297 7.266 7.266 7.266zm.375-13.36c.71.227 1.36 1.07 1.82 2.25-.554.11-1.164.172-1.82.195V1.578zm-2.57 2.25c.453-1.18 1.109-2.023 1.82-2.25v2.445a11.402 11.402 0 01-1.82-.195zm4.023-2.062c.89.273 1.695.742 2.367 1.359-.36.21-.781.383-1.25.523-.297-.765-.68-1.414-1.117-1.882zM3.383 3.125a6.179 6.179 0 012.367-1.36c-.438.47-.813 1.118-1.11 1.883a5.796 5.796 0 01-1.257-.523zm7.828 4.164c-.031-1.078-.188-2.078-.445-2.945a6.665 6.665 0 001.539-.672 6.175 6.175 0 011.453 3.617H11.21zm-9.797 0a6.175 6.175 0 011.453-3.617c.422.265.946.492 1.54.672a11.59 11.59 0 00-.454 2.945H1.414zm6.547 0V4.773c.726-.023 1.414-.109 2.055-.242.242.828.39 1.774.421 2.758H7.962zm-3.234 0c.03-.984.187-1.93.43-2.758.632.133 1.32.219 2.054.242V7.29H4.727zm-3.313.758h2.54c.03 1.094.187 2.11.452 2.984-.586.18-1.101.399-1.523.664a6.113 6.113 0 01-1.469-3.648zm3.313 0H7.21v2.555c-.734.023-1.422.109-2.055.242a11.102 11.102 0 01-.43-2.797zm3.234 2.555V8.047h2.484c-.03 1-.187 1.96-.43 2.797a12.023 12.023 0 00-2.054-.242zm2.805.43c.257-.876.421-1.891.445-2.985h2.547a6.197 6.197 0 01-1.461 3.656 6.6 6.6 0 00-1.531-.672zm-5.375.507a12.423 12.423 0 011.82-.187v2.445c-.711-.227-1.367-1.07-1.82-2.258zm2.57-.187c.656.023 1.266.085 1.82.187-.46 1.188-1.11 2.031-1.82 2.258v-2.445zm2.57.375c.461.132.875.312 1.242.515a6.253 6.253 0 01-2.328 1.344c.422-.477.79-1.11 1.086-1.86zm-7.125.515a5.097 5.097 0 011.235-.515c.289.75.656 1.382 1.078 1.851a6.114 6.114 0 01-2.313-1.336z"}})])
          )
        }
      }
    